import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import media from './media';
import live from './live';
import tabsData from './tabsData';
import identityInfo from './identityInfo';
import admin from './admin';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // device
    device: '',

    // user
    userInfo: {},

    isCoverRender: false, // 用於畫面的蓋板渲染
    isCoverCloseable: true, // 彈窗是否可點及黑幕關閉

    isGoToVip: false, // 用於是否直接導向數據中心>同學會>VIP社團
  },
  getters: {
    // device
    getDevice(state) {
      return state.device;
    },

    // userInfo
    getUserInfo(state) {
      return state.userInfo;
    },

    isCoverRender(state) {
      return state.isCoverRender;
    },
    isCoverCloseable(state) {
      return state.isCoverCloseable;
    },

    // isGoToVip
    getIsGoToVip(state) {
      return state.isGoToVip;
    },
  },
  mutations: {
    // device
    UPDATE_DEVICE(state, device) {
      state.device = device;
    },

    // userInfo
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
    },

    UPDATE_IS_COVER_RENDER(state, payload) {
      state.isCoverRender = payload.isCoverRender;
    },
    UPDATE_IS_COVER_CLOSEABLE(state, payload) {
      state.isCoverCloseable = payload.isCoverCloseable;
    },

    // isGoToVip
    UPDATE_IS_GO_TO_VIP(state, isGoToVip) {
      state.isGoToVip = isGoToVip;
    },
  },
  actions: {
    // device
    updateDevice({ commit }, device) {
      commit('UPDATE_DEVICE', device);
    },

    // userInfo
    setUserInfo({ commit }, userInfo) {
      commit('SET_USERINFO', userInfo);
    },

    updateIsCoverRender({ commit }, payload) {
      commit('UPDATE_IS_COVER_RENDER', payload);
    },

    updateIsCoverCloseable({ commit }, payload) {
      commit('UPDATE_IS_COVER_CLOSEABLE', payload);
    },

    // isGoToVip
    updateIsGoToVip({ commit }, payload) {
      commit('UPDATE_IS_GO_TO_VIP', payload);
    },
  },
  modules: {
    auth,
    // 影音相關資料
    media,
    // 作者各個頁籤顯示相關資料
    tabsData,
    // 會員登入相關資料
    identityInfo,
    // 直播相關資料
    live,
    // 無敵帳號共用資料
    admin,
  },
});
